module.exports = __webpack_public_path__ + "img/download_ios.102b8381.png";